module.exports = __webpack_public_path__ + "img/map-forward.0031154a.png";